import { render, staticRenderFns } from "./RejectedStatus.vue?vue&type=template&id=08c2995d&scoped=true&"
import script from "./RejectedStatus.vue?vue&type=script&lang=js&"
export * from "./RejectedStatus.vue?vue&type=script&lang=js&"
import style0 from "./RejectedStatus.vue?vue&type=style&index=0&id=08c2995d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c2995d",
  null
  
)

export default component.exports